import React from "react";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
} from "office-ui-fabric-react";
import { Formik } from "formik";
import { CustomTextField } from "./Library";
import * as yup from "yup";

const remarksSchema = yup.object().shape({
  remarks: yup.string().optional(),
});

export interface ManageAllRejectDialogProps {
  handleRejectCloseDialog: any;
  remarks?: string;
  subText: string;
  // handleLoading: any;
}

const ManageAllRejectDialog: React.FC<ManageAllRejectDialogProps> = ({
  handleRejectCloseDialog,
  remarks,
  subText,
}) => {
  //state
  const [state, setState] = React.useState({
    remarksObj: {
      remarks: remarks || "",
    },
    isOpen: true,
  } as {
    remarksObj: any;
    isOpen: boolean;
  });

  const closeUpdateDialog = (isSuccess: boolean, remarks?: any) => {
    handleRejectCloseDialog(isSuccess, remarks);
  };

  return (
    <React.Fragment>
      <Dialog
        hidden={!state.isOpen}
        onDismiss={() => closeUpdateDialog(false)}
        modalProps={{
          isBlocking: true,
          styles: { main: { maxWidth: 450 } },
        }}
        dialogContentProps={{
          type: DialogType.normal,
          title: "Are You Sure",
          subText: `Do you want to Reject the ${subText}`,
        }}
      >
        <Formik
          initialValues={state.remarksObj}
          validationSchema={remarksSchema}
          onSubmit={async (values: any, { setSubmitting }) => {
            let obj = { ...values };
            closeUpdateDialog(true, obj.remarks);
            setState({ ...state, isOpen: false });
            setSubmitting(false);
          }}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <CustomTextField
                name={"remarks"}
                placeholder="Enter your remarks here..."
                label="Remarks"
              />
              <DialogFooter>
                <DefaultButton
                  text="Cancel"
                  onClick={() => closeUpdateDialog(false)}
                  className="borderless-btn"
                />
                <PrimaryButton text="Yes" type="submit" />
              </DialogFooter>
            </form>
          )}
        </Formik>
      </Dialog>
    </React.Fragment>
  );
};

export default ManageAllRejectDialog;
